export const HEADER_SUBTITLE =
  'The monthly rental fees and any monthly co-payments are shown without applicable VAT.'
export const HEADER_TEXT = 'Total: 4577'
export const CARD_HEADER_ICON = 'CARD_HEADER_ICON'
